export function mapDateRange(dateRange) {
  return {
    dateFrom: dateRange[0].toISOString(),
    dateTo: dateRange[1].toISOString(),
  };
}
